import { Component, OnInit, Input, Output, OnDestroy, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, Subject, takeUntil } from 'rxjs';
import { CheckOutService } from '../CheckOut.service';
import { CheckOutActions } from '../CheckOutActions';
import { SignalRService } from 'src/app/services/signalR/SignalR.service';
import { SignalEventType } from 'src/app/services/signalR/SignalModel';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-prices-details',
  templateUrl: './prices-details.component.html'
})
export class PricesDetailsComponent extends CheckOutActions implements OnInit, OnDestroy {
  @Input() orderDetails!: any;
  @Input() priceListId!: any;
  @Input() checkoutType!: string;

  @Output() updateOrderPrices = new EventEmitter<any>();

  pricesLoading = false;

  private unsubscribe$: Subject<any> = new Subject<any>();

  getPriceSubscriber!: Subscription

  hardReload = true;
  subscriptions: Subscription[] = [];

  constructor(
    checkoutService: CheckOutService,
    translate: TranslateService,
    private signal: SignalRService
  ) {
    super(checkoutService, translate)
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.updatePaymentSettings)
        .subscribe(message => { this.signalAction(message.data); })
    )
  }

  signalAction(data: any) {
    const restId = Number(localStorage.getItem('restaurantId'))
    if (
      restId && data.RestaurantId == restId
      && this.orderDetails?.orderItems?.length
    ) {
      this.hardReload = false;
      this.ResGetTotalPrice();
    }
  }

  ngOnInit(): void {
    if (this.orderDetails) {
      this.currentOrderId = this.orderDetails.orderId;
      this.currency = this.orderDetails.currency;
    }
    // cart refresh prices
    this.checkoutService.refreshPrices.pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        if (data && this.orderDetails?.orderItems?.length) {
          this.ResGetTotalPrice();
        }
      });
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  ResGetTotalPrice() {
    this.getPriceSubscriber?.unsubscribe();
    this.pricesLoading = true;
    let orderItems: any = [];
    this.orderDetails?.orderItems?.forEach((item: any) => {
      item.cartList.forEach((data: any) => {
        const orderItem = {
          specialRequest: data.specialRequest || null,
          quantity: Number(data.quantity),
          price: Number(data.netPrice), // for Is open price, when price entered manualy
          freeQuantity: data.freeQuantity ? Number(data.freeQuantity) : 0,
          menuItemId: data.menuItemId,
          restaurantSizeId: data.restaurantSizeId,
          unWantedOptionIngrediant: data.unWantedOptionalIngredients?.map((option: any) => option.id) || [],
          variantsOptions: data.variantsOptions || [],
          additionsOptions: data.additionsOptions || []
        }
        orderItems.push(orderItem)
      })
    })
    let data = {
      orderId: this.orderDetails?.orderId || 0,
      orderItems: orderItems,
      customerUserId: this.orderDetails.customer?.customerId,
      dicount: this.orderDetails.discount,
      surcharge: this.orderDetails.surcharge,
      reservationType: this.orderDetails.reservationType,
      priceListId: this.priceListId
    }
    this.orderDetails.itemsList = orderItems;
    this.getPriceSubscriber = this.checkoutService.ResGetTotalPrice(data)
      .subscribe(
        (res: any) => {
          this.pricesLoading = false;
          // delete res?.currency;
          Object.assign(this.orderDetails, res);
          this.currency = this.orderDetails.currency;
          this.updateOrderPrices.emit(this.orderDetails); // For takeaway prices
        }, error => {
          this.pricesLoading = false;
          this.orderDetails.discount = null;
          this.ResGetTotalPrice();
          Swal.fire({
            title: this.translate.instant('swalMsg.Failed'),
            text: error.detail,
            icon: 'error',
            confirmButtonText: this.translate.instant('swalMsg.Ok')
          });
        });
  }

  removeSurcharge() {
    if (this.orderDetails.reservationType == 'TakeAway') {
      this.orderDetails.surcharge = null;
      this.ResGetTotalPrice();
    } else {
      this.ResRemoveOrderSurcharge()
    }
  }
  removeDiscount() {
    if (this.orderDetails.reservationType == 'TakeAway') {
      this.orderDetails.discount = null;
      this.ResGetTotalPrice();
    } else {
      this.ResRemoveOrderDiscount()
    }
  }

}
